module.exports = __webpack_public_path__ + "static/media/right_panel.2580ae6e.svg";